<template>
  <div>
		<div v-if="isDialog" class="examination_list on">
			<div class="exchangeTc">
				<div class="tits">
					{{title}}
					<div class="zst"></div>
				</div>
				<div class="content">
					<div class="middle">
						{{content}}
					</div>
					<!-- <div class="bottomBtn bottomBtn1" @click="cancel">取消</div> -->
					<div class="bottomBtn bottomBtn2" @click="logout">确定</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { logout } from "@/api/base";
export default {
  name: 'heartbeat',
  props: {
		
	},
	data() {
		return {
			isDialog: false,
			title: "提示",
			content: "内容数据",
		};
	},
	methods: {
		cancel(){
			var that = this;
			that.isDialog = false;
		},
	  logout() {
	    window.location.href = window.location.origin + "/ai";
	  },
	},
	components: {
		
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.examination_list {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgb(0,0,0,0.4);
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 30;	
	}
	.examination_list.on{
		display: block;
	}
	.examination_list .exchangeTc{
		width: 6rem;
		margin: 2.45rem auto 0 auto;
		position: relative;
	}
	.examination_list .tits{
		text-align: center;
		font-size: 0.18rem;
		color: #ffffff;
		line-height: 0.6rem;
		height: 0.6rem;
		position: relative;
		background-image: linear-gradient(to right, #3f85fa, #72a3f5);
		border-radius: 0.1rem 0.1rem 0 0;
	}
	.examination_list .tits .btn{
		width: 0.3rem;
		height: 0.3rem;
		background: url(//ai.cizhuangyuan.com/assets/common/cgxx_12.png) center no-repeat;
		background-size: 0.3rem;
		position: absolute;
		right: 0.3rem;
		top: 50%;
		margin-top: -0.15rem;
		cursor: pointer;
	}
	.examination_list .tits .zst{
		width: 0.77rem;
		height: 0.55rem;
		background: url(//ai.cizhuangyuan.com/assets/common/cgxx_09.png) center no-repeat;
		background-size: 0.77rem 0.55rem;
		position: absolute;
		bottom: 0;
		right: 0.2rem;
	}
	.examination_list .tits::before{
		content: '';
		display: block;
		width: 1.93rem;
		height: 0.89rem;
		background: url(//ai.cizhuangyuan.com/assets/common/tcd.png) center no-repeat;
		background-size: 1.93rem 0.89rem;
		position: absolute;
		left: 50%;
		margin-left: -0.8rem;
		bottom: -0.1rem;
		z-index: 1;
	}
	.examination_list .exchangeTc .tits:after{
		content: '';
		display: block;
		width: 1.37rem;
		height: 1.03rem;
		background: url(//ai.cizhuangyuan.com/assets/common/tctl.png) center no-repeat;
		background-size: 1.37rem 1.03rem;
		left: 0.2rem;
		bottom: -0.05rem;
		position: absolute;
	}
	.examination_list .content{
		background: #fff;
		border-radius: 0 0 0.1rem 0.1rem;
		text-align: center;
		padding-bottom: 0.8rem;
	}
	.examination_list .content .middle{
		font-size: 0.24rem;
		color: #333333;
		font-weight: bold;
		line-height: 0.48rem;
		padding: 0.5rem 0;
	}
	.examination_list .content .middle span{
		color: #de3836;
		font-weight: normal;
		padding: 0 0.1rem;
	}
	.examination_list .exchangeTc .bottomBtn{
		width: 1.37rem;
		height: 0.42rem;
		line-height: 0.42rem;
		font-size: 0.16rem;
		border-radius: 1rem;
		background: #cc0000;
		box-shadow: 0 0.04rem 0.1rem 0.04rem #e1e2e3;
		position: absolute;
		left: 50%;
		bottom: 0.45rem;
		color: #FFFFFF;
		cursor: pointer;
	}
	.examination_list .exchangeTc .bottomBtn1{
		margin-left: -1.8rem;
		background: #629af6;
	}
	.examination_list .exchangeTc .bottomBtn2{
		margin-left: -0.74rem;
	}

  .bottomBtn:hover{
    opacity: 0.8;
  }
	
</style>
